export type CurrentStep = {
  date: string;
  details: string;
  isChecked: boolean;
  key: number;
  meetsTheRequirements: number;
  user: string;
  userId: string;
  _id: string;
};

export type UserInfo = {
  firstName: string;
};

export type Candidate = {
  _id: string;
  currentStep: CurrentStep;
  userInfo: UserInfo;
};

export type InnerCandidateListProps = {
  candidates: Candidate[];
  colors: any;
};

export type InnerListProps = {
  candidates: any[];
  title?: string;
  colors: any;
};

export type CandidateListProps = {
  ignoreContainerClipping?: boolean;
  internalScroll?: boolean;
  scrollContainerStyle?: React.CSSProperties;
  isDropDisabled?: boolean;
  isCombineEnabled?: boolean;
  listId?: string;
  listType?: string;
  style?: React.CSSProperties;
  candidates: Candidate[];
  title?: string;
  useClone?: boolean;
  colors: any;
};

export interface ContainerProps {
  isDragging?: boolean;
  isGroupedOver?: boolean;
  isClone?: boolean;
  colors: {
    soft: string;
    hard: string;
  };
}

export interface Colors {
  soft: string;
}

export type CandidateShortlistKanban = {
  attachmentUrl: Array<string>;
  isReproved: boolean;
  isSelected: boolean;
  key: number;
  name: string;
}

export type CandidateMap = {
    [key: string]: any[];
};

export type DraggableLocation = {
    droppableId: string;
    index: number;
};

export interface ReorderCandidateMapArgs {
    candidateMap: CandidateMap;
    source: DraggableLocation;
    destination: DraggableLocation;
}

export interface ListType<T = any> {
    id: string;
    values: T[];
}

export interface MoveBetweenArgs<T = any> {
    list1: ListType<T>;
    list2: ListType<T>;
    source: DraggableLocation;
    destination: DraggableLocation;
}

export enum StepColors {
    "Seleção" = "#3498db",
    "Apresentação" = "#2ecc71",
    Aprovado = "#1abc9c",
    Reprovado = "#e74c3c"
}

export enum StepColorsbackground {
    "Seleção" = "#adcce0fe",
    "Apresentação" = "#a6d5baff",
    Aprovado = "#96cbc0ff",
    Reprovado = "#e7a9a3ff"
}